import React, { useState } from "react";
import { Button, FormControl, Stack } from "@mui/material";
import AutomateLiteModal from "./AutomateLiteModal";

interface DownloadScriptButtonProps {
  arn: string;
  region: string;
}

const DownloadScriptButton: React.FC<DownloadScriptButtonProps> = ({ arn, region }) => {
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <Stack direction="row">
      <FormControl fullWidth>
        <Button
          onClick={handleOpen}
          type="button"
          size="small"
          variant="contained"
          sx={{
            bgcolor: "secondary.main",
            "&:hover": {
              bgcolor: "secondary.main",
              color: "secondary.contrastText",
            },
          }}
        >
          Download Script
        </Button>
      </FormControl>
      <AutomateLiteModal
        arn={arn}
        region={region}
        open={open}
        onClose={handleClose}
      />
    </Stack>
  );
};

export default DownloadScriptButton;
